import { render } from "./FreePassGreeting.vue?vue&type=template&id=af1c7b78"
import script from "./FreePassGreeting.vue?vue&type=script&lang=js"
export * from "./FreePassGreeting.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__